import { render, staticRenderFns } from "./TaskInfoModalVehicle.vue?vue&type=template&id=6855e770&scoped=true"
import script from "./TaskInfoModalVehicle.vue?vue&type=script&lang=js"
export * from "./TaskInfoModalVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6855e770",
  null
  
)

export default component.exports